<template>
  <v-btn @click="cancelOnboarding"
         style="border: none; background-color: transparent; box-shadow: none; font-weight: bold">
    <span style="line-height: 39px">
      <slot>Prozess abbrechen</slot>
    </span>
  </v-btn>
</template>

<script>
export default {
  name: 'finCancelOnboardingButton',
  props: {
    route: { type: String, default: 'onbgetstarted' },
    callback: {
      type: Function,
      default: function () {
      }
    }
  },
  methods: {
    cancelOnboarding: function () {
      this.callback()
      this.$router.push(this.route)
    }
  }
}
</script>

<style scoped>

</style>
